const environment = import.meta.env;

export const PLATFORM_NAME = "Mai HRMS";

export const ENV_VARS = {
  API_INSTANCE: environment.VITE_API_INSTANCE,
  API_INSTANCE2: environment.VITE_API_INSTANCE,
};
